import { render } from "./OrderSupplierCreateUpdate.vue?vue&type=template&id=723a239e&scoped=true"
import script from "./OrderSupplierCreateUpdate.vue?vue&type=script&lang=js"
export * from "./OrderSupplierCreateUpdate.vue?vue&type=script&lang=js"

import "./OrderSupplierCreateUpdate.vue?vue&type=style&index=0&id=723a239e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-723a239e"]])

export default __exports__